import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { CategoryService, getActiveTopicsResolver } from '@examdojo/category/v2';
import { mapToVoid } from '@examdojo/rxjs';
import { catchError, EMPTY, first } from 'rxjs';
import { CmsUrlParts } from '../cms.model';
import { SyllabusComponent } from './syllabus.component';
import { TopicTabComponent } from './topic-level-2-detail-view/tabs/topic-tab/topic-tab.component';
import { TopicLevel2DetailViewComponent } from './topic-level-2-detail-view/topic-level-2-detail-view.component';

export const TOPIC_LEVEL_1_SLUG_PARAM = 'topicLevel1Slug';
export const TOPIC_LEVEL_2_SLUG_PARAM = 'topicLevel2Slug';

export enum TopicLevel2Tab {
  Concept = 'concept',
  Insights = 'insights',
  CheatSheet = 'cheat_sheet',
  PastPapers = 'past_papers',
}

export const SYLLABUS_ROUTES: Route[] = [
  {
    path: CmsUrlParts.Syllabus,
    component: SyllabusComponent,
    resolve: {
      syllabusTopics: () => {
        const categoryService = inject(CategoryService);
        return categoryService.fetchTopicsTree().pipe(
          first(),
          mapToVoid(),
          // error initially handled and rethrown by the service.
          catchError(() => EMPTY),
        );
      },
    },
    children: [
      {
        path: `:${TOPIC_LEVEL_1_SLUG_PARAM}/:${TOPIC_LEVEL_2_SLUG_PARAM}`,
        component: TopicLevel2DetailViewComponent,
        resolve: {
          activeTopics: getActiveTopicsResolver({
            topicLevel1SlugParam: TOPIC_LEVEL_1_SLUG_PARAM,
            topicLevel2SlugParam: TOPIC_LEVEL_2_SLUG_PARAM,
          }),
        },
        children: [
          { path: '', redirectTo: TopicLevel2Tab.Concept, pathMatch: 'full' },
          {
            path: TopicLevel2Tab.Concept,
            component: TopicTabComponent,
            data: { pageType: 'concept' },
          },
          { path: TopicLevel2Tab.CheatSheet, component: TopicTabComponent, data: { pageType: 'cheat_sheet' } },
          { path: TopicLevel2Tab.Insights, component: TopicTabComponent, data: { pageType: 'insights' } },
          { path: TopicLevel2Tab.PastPapers, component: TopicTabComponent, data: { pageType: 'past_papers' } },
        ],
      },
    ],
  },
  {
    path: 'sandbox',
    loadComponent: () => import('./editor-sandbox.component').then((m) => m.EditorSandboxComponent),
  },
];
